import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function SubscriberList() {
  const [subscribers, setSubscribers] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get('/subscriber', { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then(({ data }) => setSubscribers(Array.isArray(data) ? [...data].reverse() : []))
      .catch((err) => setError(err.response?.data?.message || 'Impossible de charger les abonnés.'));
  }, []);

  return (
    <main style={{ maxWidth: 1000, margin: '40px auto', padding: '0 24px', minHeight: '60vh' }}>
      <h1>Abonnés à la newsletter</h1>
      <p style={{ color: '#666', marginBottom: 28 }}>Adresses enregistrées depuis le formulaire du site public.</p>
      {error && <p style={{ color: '#b5122b' }}>{error}</p>}
      <div style={{ border: '1px solid #e4e4ec', borderRadius: 12, overflow: 'hidden', background: '#fff' }}>
        {subscribers.map((subscriber, index) => (
          <div key={subscriber.id || subscriber.email} style={{ display: 'flex', justifyContent: 'space-between', gap: 16, padding: '16px 20px', borderBottom: index < subscribers.length - 1 ? '1px solid #eee' : 'none' }}>
            <a href={`mailto:${subscriber.email}`}>{subscriber.email}</a>
            {subscriber.createdAt && <span style={{ color: '#777' }}>{new Date(subscriber.createdAt).toLocaleString('fr-FR')}</span>}
          </div>
        ))}
        {!error && subscribers.length === 0 && <p style={{ padding: '8px 20px' }}>Aucun abonné pour le moment.</p>}
      </div>
    </main>
  );
}
